import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import IRPlayerRow from './components/IRPlayerRow';

import LeagueNavbar from '../shared/LeagueNavbar';
import TeamHeader from './components/TeamHeader';

import './Team.css';
import DroppedPlayerRow from './components/DroppedPlayerRow';
import RosterPlayerRow from './components/RosterPlayerRow';
import UnsignedPlayerSection from './components/UnsignedPlayerSection';
import SortableHeader, { sortPlayers } from './components/TeamTableSort';

const Team = () => {
  const { league_key, league_team_id } = useParams();
  const [data, setData] = useState(null);
  const [teamCapSummary, setTeamCapSummary] = useState(null);
  const [tableSorts, setTableSorts] = useState({
    roster: { key: 'salary', direction: 'desc' },
    ir: { key: 'salary', direction: 'desc' },
    dropped: { key: 'salary', direction: 'desc' },
  });

  console.log(league_key, league_team_id);
  const updateData = (newData) => {
    setTeamCapSummary(newData);
    console.log("Updated data in Team.js:", newData);
  };

  const toggleSort = (table, key) => {
    setTableSorts((current) => ({
      ...current,
      [table]: {
        key,
        direction: current[table].key === key && current[table].direction === 'desc'
          ? 'asc'
          : 'desc',
      },
    }));
  };

  useEffect(() => {
    // Using the environment variable here
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/league/${league_key}/${league_team_id}`;
    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        setData(data);
        setTeamCapSummary(data?.team?.team_cap_summary);
      });
  }, [league_key, league_team_id]);

    useEffect(() => {
      console.log('Updated teamCapSummary:', teamCapSummary);
      }, [teamCapSummary]);

  return (
    <div>
      {/* Conditionally render LeagueNavbar */}
      {data && <LeagueNavbar teams={data.navbar_teams} league_key={league_key} />}

      <div className='page-content'>

        <TeamHeader team={data?.team} team_cap_summary={teamCapSummary} />

        <UnsignedPlayerSection unsigned_players={data?.unsigned_roster} updateData={updateData} team_cap_summary={teamCapSummary}/>

        
        <div>
          <Table responsive bordered hover className='table'>
            <thead>
              <tr>
                <SortableHeader label="Player" column="player_name" sort={tableSorts.roster} onSort={(key) => toggleSort('roster', key)} className="name-th" />
                <SortableHeader label="Salary" column="salary" sort={tableSorts.roster} onSort={(key) => toggleSort('roster', key)} />
                <SortableHeader label="Market Value" column="auction_value" sort={tableSorts.roster} onSort={(key) => toggleSort('roster', key)} />
                <SortableHeader label="Years" column="contract_length" sort={tableSorts.roster} onSort={(key) => toggleSort('roster', key)} />
              </tr>
            </thead>
            <tbody>
              {sortPlayers(data?.current_roster, tableSorts.roster).map((player_contract) => (
                <RosterPlayerRow key={player_contract.player_key} player={player_contract} />
              ))}
            </tbody>
          </Table>
        </div>

        {data?.ir_players?.length > 0 ? (
        <div className="IR-table">
          <h3> IR Players </h3>
          <Table responsive bordered hover className='table'>
            <thead>
              <tr>
                <SortableHeader label="Player" column="player_name" sort={tableSorts.ir} onSort={(key) => toggleSort('ir', key)} className="name-th" />
                <SortableHeader label="Salary" column="salary" sort={tableSorts.ir} onSort={(key) => toggleSort('ir', key)} />
                <SortableHeader label="Market Value" column="auction_value" sort={tableSorts.ir} onSort={(key) => toggleSort('ir', key)} />
                <SortableHeader label="Years" column="contract_length" sort={tableSorts.ir} onSort={(key) => toggleSort('ir', key)} />
                <SortableHeader label="Salary Relief" column="salary_relief" sort={tableSorts.ir} onSort={(key) => toggleSort('ir', key)} />
                <SortableHeader label="Contract Relief" column="contract_relief" sort={tableSorts.ir} onSort={(key) => toggleSort('ir', key)} />
              </tr>
            </thead>
            <tbody>
              {sortPlayers(data?.ir_players, tableSorts.ir).map((player_contract) => (
                <IRPlayerRow key={player_contract.player_key} player={player_contract} />
              ))}
            </tbody>
          </Table>
        </div>
        ) : null}

      {data?.dropped_players?.length > 0 ? (
      <div>
        <h3> Dropped Players </h3>
        <Table responsive bordered hover className='table'>
          <thead>
            <tr>
              <SortableHeader label="Player" column="player_name" sort={tableSorts.dropped} onSort={(key) => toggleSort('dropped', key)} className="name-th" />
              <SortableHeader label="Salary" column="salary" sort={tableSorts.dropped} onSort={(key) => toggleSort('dropped', key)} />
              <SortableHeader label="Market Value" column="auction_value" sort={tableSorts.dropped} onSort={(key) => toggleSort('dropped', key)} />
              <SortableHeader label="Years" column="contract_length" sort={tableSorts.dropped} onSort={(key) => toggleSort('dropped', key)} />
              <SortableHeader label="Cap Penalty" column="cap_penalty" sort={tableSorts.dropped} onSort={(key) => toggleSort('dropped', key)} />
            </tr>
          </thead>
          <tbody>
            {sortPlayers(data?.dropped_players, tableSorts.dropped).map((player_contract) => (
              <DroppedPlayerRow key={player_contract.player_key} player={player_contract} />
            ))}
          </tbody>
        </Table>
      </div>
      ) : null}

    </div>
  </div>
  );
};

export default Team;
